import { AuxNotificationGroup } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum, AuxNotificationFooterTypeEnum, AuxNotificationStyleEnum } from "@blk/aladdin-web-components";
import { push } from "connected-react-router";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { CallbackComponent as BaseCallbackComponent } from "redux-oidc";
import "./oidcCallback.scss";
import { InsProgressIndicator } from "./widgets/base/insProgressIndicator";
import { language } from "language/default";
import { appInsightsPrepareAuthenticatedUserContext, appInsightsTrackException, appInsightsTrackTrace } from "plugins/app-insight-init";
import { userManager } from "plugins/oidc";
const CallbackComponent = BaseCallbackComponent;
export const OidcCallback = () => {
    const dispatch = useDispatch();
    const [anErrorOccured, setAnErrorOccured] = useState(false);
    return (React.createElement(CallbackComponent, { userManager: userManager, successCallback: (user) => {
            try {
                const validatedUserId = user.profile?.ins_ux_user_iqid?.replace(/[,;=| ]+/ug, "_");
                appInsightsPrepareAuthenticatedUserContext(validatedUserId, user.profile?.role, true);
            }
            finally {
                const { path, origin } = user.state;
                try {
                    // Test if URL is correct
                    new URL(path, origin) && dispatch(push(path));
                }
                catch {
                    // Incorrect url, redirect to home
                    dispatch(push("/"));
                }
            }
        }, errorCallback: (error) => {
            try {
                appInsightsTrackException({ exception: error });
                appInsightsTrackTrace({ message: language.en.authentication.failed });
            }
            finally {
                setAnErrorOccured(true);
            }
        } }, anErrorOccured
        ? React.createElement("div", { className: "authentication_error_notification" },
            React.createElement(AuxNotificationGroup, { config: [
                    {
                        buttons: [
                            {
                                buttonType: AuxButtonTypeEnum.PRIMARY,
                                clickCallback: () => {
                                    window.location.href = "/";
                                },
                                label: language.en.authentication.tryAgain,
                                type: AuxNotificationFooterTypeEnum.BUTTON
                            }
                        ],
                        id: "error",
                        message: language.en.authentication.failed,
                        notificationStyle: AuxNotificationStyleEnum.WARNING,
                        showCloseIcon: false
                    }
                ], openOnLoad: true }))
        : React.createElement("div", { className: "app-loading" },
            React.createElement(InsProgressIndicator, null))));
};
